export const IMAGES = {
  logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_org-web-builder/artifacts/mowzkarc_IMG-20260803-WA0041.jpg",
  banner: "https://customer-assets-eiarnc6j.emergentagent.net/job_org-web-builder/artifacts/s2jodypn_IMG-20260803-WA0042.jpg",
  hero: "https://images.unsplash.com/photo-1723962381764-36f6384885f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  community: "https://images.pexels.com/photos/37895093/pexels-photo-37895093.jpeg?auto=compress&cs=tinysrgb&w=1400",
  family: "https://images.unsplash.com/photo-1689934246598-63ab2250c08e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  classroom: "https://images.unsplash.com/photo-1781519616226-e116859349df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  family2: "https://images.unsplash.com/photo-1670792075280-f1251f5470ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const content = {
  it: {
    nav: { about: "Chi Siamo", manifesto: "Valori", sportello: "Sportello", projects: "Progetti", events: "Eventi", news: "News", gallery: "Galleria", roadmap: "2026–2030", join: "Diventa Socio" },
    hero: {
      badge: "APS · Rende (CS)",
      lineTop: "Possiamo fare",
      lineMidA: "di ",
      lineMidEm: "più",
      lineMidB: " per i",
      lineBottom: "nostri figli.",
      slogan: "La voce dei genitori, il futuro dei nostri figli.",
      sub: "AGE Rende APS accompagna le famiglie nella vita scolastica e sociale. Ascolto, partecipazione e dialogo per costruire una comunità educante.",
      ctaPrimary: "Diventa Socio",
      ctaSecondary: "Scopri lo Sportello",
    },
    marquee: ["Ascolto", "Partecipazione", "Dialogo", "Inclusione", "Legalità", "Volontariato", "Responsabilità", "Innovazione"],
    pillars: {
      tag: "Insieme per una scuola migliore",
      title: "I nostri pilastri.",
      list: [
        { t: "Partecipazione", d: "La forza dei genitori nelle scuole." },
        { t: "Educazione", d: "Formazione e progetti per crescere insieme." },
        { t: "Dialogo", d: "Ascolto e confronto costruttivo." },
        { t: "Solidarietà", d: "Inclusione e supporto per ogni famiglia." },
        { t: "Territorio", d: "Per una comunità educante attiva." },
      ],
    },
    news: {
      tag: "News & Eventi",
      title: "Dalla nostra comunità.",
      empty: "Nessuna notizia al momento. Torna presto!",
      filterAll: "Tutte",
      share: "Condividi",
    },
    gallery: {
      tag: "Galleria",
      title: "Le nostre attività.",
      subtitle: "Sfoglia gli album degli eventi vissuti insieme alla comunità educante.",
      back: "Torna al sito",
      empty: "La galleria è in arrivo. Gli album delle attività appariranno qui.",
      cta: "Vedi la galleria",
      photos: "foto",
      allAlbums: "Tutti gli album",
    },
    calendar: {
      tag: "Calendario",
      title: "Prossimi appuntamenti.",
      next: "Prossimo evento",
      none: "Nessun evento in programma.",
      weekdays: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
      days: "giorni", hours: "ore", mins: "min",
      eventsOn: "Eventi del giorno",
      today: "Oggi",
    },
    newsletter: {
      tag: "Resta aggiornato",
      title: "Iscriviti alla newsletter.",
      subtitle: "Ricevi news ed eventi della comunità, anche senza diventare socio.",
      placeholder: "La tua email",
      button: "Iscriviti",
      sending: "Invio...",
      success: "Iscrizione confermata! Controlla la tua email.",
      error: "Errore, riprova.",
    },
    admin: {
      loginTitle: "Area Soci",
      loginSub: "Accesso riservato al direttivo.",
      email: "Email", password: "Password", login: "Accedi", logout: "Esci",
      loginError: "Credenziali non valide.",
      backHome: "Torna al sito",
      dashTitle: "Pannello Direttivo",
      tabMembers: "Richieste di adesione", tabNews: "News & Eventi",
      newsForm: "Pubblica una news",
      f: { titolo_it: "Titolo (IT)", titolo_en: "Titolo (EN)", testo_it: "Testo (IT)", testo_en: "Testo (EN)", data: "Data", categoria: "Categoria", image: "Foto attività (opzionale)" },
      publish: "Pubblica", publishing: "Pubblicazione...", delete: "Elimina", uploading: "Caricamento foto...",
      update: "Aggiorna", cancel: "Annulla modifica", editLabel: "Modifica",
      colStatus: "Stato", export: "Esporta Excel", addPhotos: "Aggiungi foto (una o più)",
      statuses: { nuovo: "Nuovo", contattato: "Contattato", approvato: "Approvato" },
      noMembers: "Nessuna richiesta ancora.", noNews: "Nessuna news pubblicata.",
      colName: "Nome", colEmail: "Email", colPhone: "Telefono", colCity: "Città", colVol: "Volontario", colDate: "Data",
      tabSubscribers: "Iscritti Newsletter", colSubEmail: "Email", colSubDate: "Iscritto il", exportSubs: "Esporta iscritti", noSubs: "Nessun iscritto.",
    },
    about: {
      tag: "01 — Chi Siamo",
      title: "Nati da una domanda semplice.",
      body: "AGE Rende nasce da una domanda: «Possiamo fare di più per i nostri figli?». Non per sostituire la scuola né per contrapporci alle istituzioni, ma per camminare al loro fianco, offrendo alle famiglie uno spazio di partecipazione, ascolto e responsabilità condivisa.",
      body2: "Immaginiamo una città in cui ogni scuola sia parte di una comunità educativa aperta, inclusiva e solidale. Una comunità in cui nessun genitore si senta solo e ogni ragazzo possa crescere sentendosi accolto, valorizzato e sostenuto.",
      stats: [
        { n: "2026", l: "Anno di costituzione" },
        { n: "20+", l: "Progetti in programma" },
        { n: "1", l: "Sportello Genitori" },
      ],
    },
    mission: {
      tag: "02 — Missione & Visione",
      missionTitle: "La nostra Missione",
      mission: "Promuovere la partecipazione responsabile delle famiglie alla vita scolastica e sociale, sostenere il dialogo educativo, favorire il benessere degli studenti e costruire una rete territoriale capace di ascoltare, orientare e accompagnare.",
      visionTitle: "La nostra Visione",
      vision: "Una comunità in cui nessun genitore si senta solo e ogni ragazzo possa crescere sentendosi accolto, valorizzato e sostenuto.",
    },
    manifesto: {
      tag: "03 — Carta dei Valori",
      title: "Il nostro Manifesto.",
      values: [
        { t: "Ascolto", d: "Accogliere ogni persona senza pregiudizio, con attenzione e rispetto." },
        { t: "Partecipazione", d: "Rendere i genitori protagonisti responsabili della comunità scolastica." },
        { t: "Dialogo", d: "Preferire il confronto costruttivo alla contrapposizione." },
        { t: "Inclusione", d: "Valorizzare differenze, fragilità e talenti." },
        { t: "Legalità", d: "Agire con correttezza, trasparenza e rispetto delle regole." },
        { t: "Volontariato", d: "Dedicare tempo e competenze al bene comune." },
        { t: "Responsabilità", d: "Assumere impegni chiari e verificarne i risultati." },
        { t: "Innovazione", d: "Preparare famiglie e ragazzi alle trasformazioni del presente e del futuro." },
      ],
    },
    sportello: {
      tag: "04 — Il servizio",
      title: "Lo Sportello Genitori a Scuola.",
      body: "Il primo passo del nostro cammino: un nuovo modo di intendere il rapporto scuola-famiglia. Uno spazio di ascolto, informazione e orientamento aperto a tutti i genitori.",
      services: [
        "Ascolto e primo orientamento",
        "Orientamento scolastico ed educativo",
        "Informazioni su DSA, BES, disabilità e inclusione",
        "Supporto alla partecipazione agli organi collegiali",
        "Incontri con esperti e percorsi formativi",
        "Invio ai servizi competenti quando necessario",
      ],
    },
    projects: {
      tag: "05 — Progetti",
      title: "Un piano di attività per la comunità.",
      list: [
        { t: "Scuola per Genitori", d: "Incontri mensili con esperti su temi educativi." },
        { t: "Genitori Digitali", d: "Social, privacy, cyberbullismo e intelligenza artificiale." },
        { t: "Insieme contro il Bullismo", d: "Laboratori e campagne di sensibilizzazione." },
        { t: "Orientiamoci", d: "Sostegno nelle transizioni tra ordini di scuola." },
        { t: "Famiglie e Inclusione", d: "DSA, BES, disabilità e accesso ai servizi." },
        { t: "Educazione alla Legalità", d: "Incontri e laboratori con esperti e istituzioni." },
        { t: "Educazione Finanziaria", d: "Budget, risparmio, credito e prevenzione." },
        { t: "Benessere Psicologico", d: "Prevenzione, alfabetizzazione emotiva e ascolto." },
        { t: "Leggere Insieme", d: "Promozione della lettura e incontri letterari." },
      ],
    },
    events: {
      tag: "06 — Eventi",
      title: "Momenti di comunità.",
      list: [
        { t: "Festa della Comunità Educante", d: "Una giornata di festa, incontro e partecipazione per tutto il territorio." },
        { t: "Settimana della Genitorialità", d: "Incontri, laboratori e confronti dedicati ai genitori." },
        { t: "Forum dei Genitori", d: "Ascolto, discussione e co-progettazione tra famiglie e scuola." },
        { t: "Giornata del Volontariato Educativo", d: "Valorizzare il tempo e le competenze donate alla comunità." },
      ],
    },
    roadmap: {
      tag: "07 — Piano Strategico",
      title: "AGE Rende 2026 → 2030.",
      steps: [
        { y: "2026", t: "Costituzione", d: "Nascita dell'associazione, tesseramento e attivazione dello Sportello Genitori." },
        { y: "2027", t: "Radicamento", d: "Iscrizione al RUNTS e prime reti stabili con scuole e istituzioni." },
        { y: "2028", t: "Espansione", d: "Nuovi progetti su inclusione, legalità e cittadinanza attiva." },
        { y: "2029", t: "Rete territoriale", d: "Costruzione di una comunità educante diffusa su tutto il territorio." },
        { y: "2030", t: "Consolidamento", d: "Un modello stabile, sostenibile e replicabile di partecipazione." },
      ],
    },
    join: {
      tag: "08 — Diventa Socio",
      title: "Cammina al nostro fianco.",
      body: "Compila il modulo: ti contatteremo per accoglierti nella comunità educante di AGE Rende.",
      fields: { nome: "Nome", cognome: "Cognome", email: "Email", telefono: "Telefono", scuola: "Scuola dei figli", citta: "Città", messaggio: "Messaggio (facoltativo)", volontariato: "Sono disponibile per il volontariato", privacy: "Acconsento al trattamento dei dati personali (Privacy)" },
      submit: "Invia richiesta",
      submitting: "Invio in corso...",
      successTitle: "Richiesta inviata!",
      success: "Grazie! Abbiamo ricevuto la tua richiesta e ti contatteremo presto.",
      error: "Si è verificato un errore. Riprova.",
      privacyError: "Devi accettare la privacy per procedere.",
    },
    contact: {
      tag: "Contatti",
      title: "Parliamone.",
      body: "Hai una domanda o vuoi collaborare? Scrivici.",
      nome: "Nome", email: "Email", messaggio: "Messaggio", submit: "Invia messaggio",
      success: "Messaggio inviato, grazie!",
      seat: "Sede operativa", seatVal: "Rende (CS)",
      president: "Presidente", presidentVal: "Dott.ssa Maria Stabilito",
      emailLabel: "Email", emailVal: "agerende@age.it",
    },
    footer: { tagline: "Una comunità educante aperta, inclusiva e solidale.", rights: "Tutti i diritti riservati." },
  },

  en: {
    nav: { about: "About", manifesto: "Values", sportello: "Help Desk", projects: "Projects", events: "Events", news: "News", gallery: "Gallery", roadmap: "2026–2030", join: "Become a Member" },
    hero: {
      badge: "APS · Rende (CS)",
      lineTop: "Can we do",
      lineMidA: "",
      lineMidEm: "more",
      lineMidB: " for our",
      lineBottom: "children?",
      slogan: "The voice of parents, the future of our children.",
      sub: "AGE Rende APS supports families in school and social life. Listening, participation and dialogue to build an educating community.",
      ctaPrimary: "Become a Member",
      ctaSecondary: "Discover the Help Desk",
    },
    marquee: ["Listening", "Participation", "Dialogue", "Inclusion", "Legality", "Volunteering", "Responsibility", "Innovation"],
    pillars: {
      tag: "Together for a better school",
      title: "Our pillars.",
      list: [
        { t: "Participation", d: "The strength of parents in schools." },
        { t: "Education", d: "Training and projects to grow together." },
        { t: "Dialogue", d: "Listening and constructive exchange." },
        { t: "Solidarity", d: "Inclusion and support for every family." },
        { t: "Territory", d: "For an active educating community." },
      ],
    },
    news: {
      tag: "News & Events",
      title: "From our community.",
      empty: "No news yet. Check back soon!",
      filterAll: "All",
      share: "Share",
    },
    gallery: {
      tag: "Gallery",
      title: "Our activities.",
      subtitle: "Browse the albums of events we lived together with the educating community.",
      back: "Back to site",
      empty: "The gallery is coming soon. Activity albums will appear here.",
      cta: "View the gallery",
      photos: "photos",
      allAlbums: "All albums",
    },
    calendar: {
      tag: "Calendar",
      title: "Upcoming events.",
      next: "Next event",
      none: "No scheduled events.",
      weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      days: "days", hours: "hours", mins: "min",
      eventsOn: "Events on this day",
      today: "Today",
    },
    newsletter: {
      tag: "Stay updated",
      title: "Subscribe to the newsletter.",
      subtitle: "Get community news and events, even without becoming a member.",
      placeholder: "Your email",
      button: "Subscribe",
      sending: "Sending...",
      success: "Subscription confirmed! Check your email.",
      error: "Error, please retry.",
    },
    admin: {
      loginTitle: "Members Area",
      loginSub: "Reserved access for the board.",
      email: "Email", password: "Password", login: "Sign in", logout: "Sign out",
      loginError: "Invalid credentials.",
      backHome: "Back to site",
      dashTitle: "Board Dashboard",
      tabMembers: "Membership requests", tabNews: "News & Events",
      newsForm: "Publish news",
      f: { titolo_it: "Title (IT)", titolo_en: "Title (EN)", testo_it: "Text (IT)", testo_en: "Text (EN)", data: "Date", categoria: "Category", image: "Activity photo (optional)" },
      publish: "Publish", publishing: "Publishing...", delete: "Delete", uploading: "Uploading photo...",
      update: "Update", cancel: "Cancel edit", editLabel: "Edit",
      colStatus: "Status", export: "Export Excel", addPhotos: "Add photos (one or more)",
      statuses: { nuovo: "New", contattato: "Contacted", approvato: "Approved" },
      noMembers: "No requests yet.", noNews: "No news published.",
      colName: "Name", colEmail: "Email", colPhone: "Phone", colCity: "City", colVol: "Volunteer", colDate: "Date",
      tabSubscribers: "Newsletter subscribers", colSubEmail: "Email", colSubDate: "Subscribed on", exportSubs: "Export subscribers", noSubs: "No subscribers.",
    },
    about: {
      tag: "01 — About Us",
      title: "Born from a simple question.",
      body: "AGE Rende was born from a question: “Can we do more for our children?”. Not to replace schools or oppose institutions, but to walk alongside them, offering families a space for participation, listening and shared responsibility.",
      body2: "We imagine a city where every school is part of an open, inclusive and supportive educational community — where no parent feels alone and every child can grow feeling welcomed, valued and supported.",
      stats: [
        { n: "2026", l: "Year founded" },
        { n: "20+", l: "Planned projects" },
        { n: "1", l: "Parents Help Desk" },
      ],
    },
    mission: {
      tag: "02 — Mission & Vision",
      missionTitle: "Our Mission",
      mission: "To promote the responsible participation of families in school and social life, support educational dialogue, foster student well-being and build a territorial network able to listen, guide and accompany.",
      visionTitle: "Our Vision",
      vision: "A community where no parent feels alone and every child can grow feeling welcomed, valued and supported.",
    },
    manifesto: {
      tag: "03 — Charter of Values",
      title: "Our Manifesto.",
      values: [
        { t: "Listening", d: "Welcoming every person without prejudice, with care and respect." },
        { t: "Participation", d: "Making parents responsible protagonists of the school community." },
        { t: "Dialogue", d: "Preferring constructive dialogue over opposition." },
        { t: "Inclusion", d: "Valuing differences, vulnerabilities and talents." },
        { t: "Legality", d: "Acting with correctness, transparency and respect for the rules." },
        { t: "Volunteering", d: "Dedicating time and skills to the common good." },
        { t: "Responsibility", d: "Taking on clear commitments and verifying results." },
        { t: "Innovation", d: "Preparing families and children for present and future change." },
      ],
    },
    sportello: {
      tag: "04 — The service",
      title: "The Parents Help Desk at School.",
      body: "The first step of our journey: a new way to understand the school–family relationship. A space of listening, information and guidance open to all parents.",
      services: [
        "Listening and first guidance",
        "School and educational orientation",
        "Info on learning disorders, special needs, disability & inclusion",
        "Support for participation in school bodies",
        "Meetings with experts and training paths",
        "Referral to competent services when needed",
      ],
    },
    projects: {
      tag: "05 — Projects",
      title: "An activity plan for the community.",
      list: [
        { t: "School for Parents", d: "Monthly meetings with experts on educational topics." },
        { t: "Digital Parents", d: "Social media, privacy, cyberbullying and AI." },
        { t: "Together Against Bullying", d: "Workshops and awareness campaigns." },
        { t: "Let's Orient Ourselves", d: "Support in transitions between school levels." },
        { t: "Families & Inclusion", d: "Learning disorders, special needs, disability & access." },
        { t: "Education to Legality", d: "Meetings and workshops with experts and institutions." },
        { t: "Financial Education", d: "Budgeting, saving, credit and prevention." },
        { t: "Psychological Well-being", d: "Prevention, emotional literacy and listening." },
        { t: "Reading Together", d: "Reading promotion and literary encounters." },
      ],
    },
    events: {
      tag: "06 — Events",
      title: "Moments of community.",
      list: [
        { t: "Educating Community Festival", d: "A day of celebration, encounter and participation for the whole area." },
        { t: "Parenting Week", d: "Meetings, workshops and dialogue dedicated to parents." },
        { t: "Parents Forum", d: "Listening, discussion and co-design between families and school." },
        { t: "Educational Volunteering Day", d: "Valuing time and skills donated to the community." },
      ],
    },
    roadmap: {
      tag: "07 — Strategic Plan",
      title: "AGE Rende 2026 → 2030.",
      steps: [
        { y: "2026", t: "Foundation", d: "Birth of the association, membership and launch of the Help Desk." },
        { y: "2027", t: "Rooting", d: "RUNTS registration and first stable networks with schools." },
        { y: "2028", t: "Expansion", d: "New projects on inclusion, legality and active citizenship." },
        { y: "2029", t: "Territorial network", d: "Building an educating community across the whole area." },
        { y: "2030", t: "Consolidation", d: "A stable, sustainable and replicable model of participation." },
      ],
    },
    join: {
      tag: "08 — Become a Member",
      title: "Walk alongside us.",
      body: "Fill in the form: we'll contact you to welcome you into the AGE Rende educating community.",
      fields: { nome: "First name", cognome: "Last name", email: "Email", telefono: "Phone", scuola: "Children's school", citta: "City", messaggio: "Message (optional)", volontariato: "I'm available for volunteering", privacy: "I consent to the processing of my personal data (Privacy)" },
      submit: "Send request",
      submitting: "Sending...",
      successTitle: "Request sent!",
      success: "Thank you! We've received your request and will contact you soon.",
      error: "Something went wrong. Please try again.",
      privacyError: "You must accept the privacy policy to proceed.",
    },
    contact: {
      tag: "Contact",
      title: "Let's talk.",
      body: "Have a question or want to collaborate? Write to us.",
      nome: "Name", email: "Email", messaggio: "Message", submit: "Send message",
      success: "Message sent, thank you!",
      seat: "Operational seat", seatVal: "Rende (CS)",
      president: "President", presidentVal: "Dr. Maria Stabilito",
      emailLabel: "Email", emailVal: "agerende@age.it",
    },
    footer: { tagline: "An open, inclusive and supportive educating community.", rights: "All rights reserved." },
  },
};
